import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'pm-ui-confirm-alert-duplicate-so',
  templateUrl: './confirm-alert-duplicate-so.component.html',
  styleUrls: ['./confirm-alert-duplicate-so.component.scss']
})
export class ConfirmAlertDuplicateSOComponent {

  readonly message: string = '';

  constructor(private bsModalRef: BsModalRef) { }

  onConfirm = (isConfirmed: boolean): void => {
    if (this.bsModalRef?.content.callback)
      this.bsModalRef?.content.callback(isConfirmed);

    this.onClose();
  }

  onClose = (): void => {
    this.bsModalRef?.hide();
  }
}
